import { Competitions, CompetitionSchools } from "../apiClient/endpoints";
import Axios from "../apiClient/instance/Axios";

export const CompetitionsService = () => {
  return Axios.get(Competitions);
};

export const SchoolsService = (competitionId) => {
  return Axios.get(
    CompetitionSchools.replace("{competitionId}", competitionId)
  );
};

export const ClassesService = (competitionId, schoolId) => {
  return Axios.get(`/competition/${competitionId}/school/${schoolId}/classes/`);
};

export const AddClassService = (schoolId, values) => {
  return Axios.post(`/school/${schoolId}/create-class/`, values);
};

export const StudentsService = (classCode) => {
  return Axios.get(`/class/${classCode}/students/`);
};

export const AddNewStudentService = (classCode, values) => {
  return Axios.post(`class/${classCode}/create-student/`, values);
};

export const SearchStudentService = (email) => {
  return Axios.get(`student/${email}/search/`);
};

export const AddExistingStudentService = (classCode, data) => {
  return Axios.post(`class/${classCode}/add-student/`, data);
};

export const DeleteStudentService = (classCode, studentId) => {
  return Axios.delete(`/class/${classCode}/student/${studentId}/remove/`);
};

export const StudentsStatusService = (competitionId, classCode) => {
  return Axios.get(`/competition/${competitionId}/class/${classCode}/status/`);
};

export const SyllabusService = (competitionId) => {
  return Axios.get(`/competition/${competitionId}/syllabus/`);
};

export const b64DecodeUnicode = (str) => {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(
    atob(str)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
};
